import React from 'react'
import getAllSuppliers from '../../Services/suppliers/getAllSuppliers'


export default async function getSuppliersData() {
    let response = await getAllSuppliers();
    return response
}
